import { render, staticRenderFns } from "./dots-loader-receipt-header.vue?vue&type=template&id=2fc7bf95&scoped=true"
import script from "./dots-loader-receipt-header.vue?vue&type=script&lang=ts&setup=true"
export * from "./dots-loader-receipt-header.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./dots-loader-receipt-header.vue?vue&type=style&index=0&id=2fc7bf95&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7bf95",
  null
  
)

export default component.exports